
import React, { useEffect, useState } from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const MonthEnergyCompare = () => {
  const [month, setMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  });

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const plants = ['SLS', 'Sweelee'];

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);

        const results = await Promise.all(
          plants.map(plant =>
            fetch('/api/monthenergygraph', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ plant, Date: month })
            }).then(res => res.json())
          )
        );

        const plantData = results.map(result => ({
          xAxis: result.data.xAxis,
          yield: result.data["Yield kWh"]
        }));

        const commonDays = plantData[0].xAxis.filter(day =>
          plantData[1].xAxis.includes(day)
        );

        const dayEnergyMaps = plantData.map(p => {
          const map = {};
          p.xAxis.forEach((day, idx) => {
            map[day] = p.yield[idx];
          });
          return map;
        });

        const combinedData = commonDays.map(day => ({
          day,
          SLS: dayEnergyMaps[0][day] || 0,
          Sweelee: dayEnergyMaps[1][day] || 0
        }));

        setData(combinedData);
      } catch (err) {
        console.error("Error fetching monthly comparison data:", err);
      } finally {
        setLoading(false);
      }
    }

    if (month) fetchData();
  }, [month]);

  return (
    <div style={{ padding: '20px',backgroundColor:"white" }}>
      {/* <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '20px' }}> */}
        <h6 className="text-lg font-bold">
          Inverter (combined 2 inverters reading) Comparison: Sweelee Huawei vs Trek Datalogger (
          {new Date(month).toLocaleString('default', { month: 'long', year: 'numeric' })})
        </h6>
        <input
          type="month"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
           style={{
        width: '140px',  
        padding: '8px',
        border: '1px solid #ccc',
        borderRadius: '6px',
        fontWeight: 'bold'
      }}        />
      {/* </div> */}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="day"
              label={{
                value: `Day of Month (${new Date(month).toLocaleString('default', { month: 'long' })})`,
                position: "insideBottomRight",
                offset: -2
              }}
            />
            <YAxis label={{ value: "Energy (kWh)", angle: -90, position: "insideLeft" }} />
      
            {/* <Tooltip  /> */}
            <Tooltip formatter={(value) => `${value} kWh`} />

            <Legend verticalAlign="top" />
            <Line type="monotone" dataKey="SLS" name="TrekSecureDatalogger" stroke="#003366" dot={false} />
            <Line type="monotone" dataKey="Sweelee" name="HuaweiDatalogger" stroke="#8B0000" dot={false} />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default MonthEnergyCompare;
